import { useGetDispatcherCustomerUpcomingQuery } from '@/services/dispatcher/dispather'

import DotsSvg from '@/assets/img/dots.svg'
import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

import Dropdown from '@/compoments/common/Dropdown'
import DropdownList from '@/compoments/DropdownList'
import UserPart from '@/compoments/common/UserPart'
import { format } from 'date-fns'
import {
    enumPillStatusesClasses,
    enumPillStatusesText,
} from '@/types/tenant/workGroup.types'
import clsx from 'clsx'
import PageLoader from '@/compoments/PageLoader'

const UncomingTab = () => {
    const { id } = useParams()
    const [searchParams] = useSearchParams()
    const queryString = searchParams.toString()
    const { data, isLoading } = useGetDispatcherCustomerUpcomingQuery(
        {
            id: Number(id),
            query: `no_limit=true&${queryString}`,
        },
        { skip: !id || !searchParams.get('startDate') },
    )
    const pageData = data?.data
    if (isLoading) {
        return <PageLoader className="h-full" />
    }
    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Date</th>
                    <th>Service</th>
                    <th style={{ width: 250 }}>Address</th>
                    <th>Technician</th>
                    <th>Status</th>
                    <th style={{ width: 10 }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {pageData && pageData.orders.length > 0 ? (
                    pageData.orders.map((order, index) => (
                        <tr key={index}>
                            <td>
                                <span className="text-color-1">
                                    {' '}
                                    {format(order.startTime, 'MMM dd, yyyy')}
                                </span>
                            </td>
                            <td>{order.service.name}</td>
                            <td>
                                <span className="text--12 text-color-1 text-wrap">
                                    {`${order.address.street}, ${order.address.city}, ${order.address.state} ${order.address.postalCode}, ${order.address.country}`}
                                </span>
                            </td>
                            <td>
                                <UserPart
                                    name={order.technician.fullName}
                                    src={order.technician.photo}
                                />
                            </td>
                            <td>
                                <span
                                    className={clsx(
                                        'pill',
                                        enumPillStatusesClasses[order.status],
                                    )}
                                >
                                    {enumPillStatusesText[order.status]}
                                </span>
                            </td>
                            <td className="text-right sticky-end">
                                <Dropdown
                                    closeSelf={true}
                                    dropdownClasses="flex flex-col"
                                    button={
                                        <span className="ico">
                                            <img src={DotsSvg} alt="" />
                                        </span>
                                    }
                                    menuClassName="dropdown-md"
                                    menu={<DropdownList list={[]} />}
                                />
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={5}>
                            <h4 className="text-center">
                                Upcoming Appointments not found
                            </h4>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    )
}

export default UncomingTab
